interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors";

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${btnBase} border border-background-300 bg-background-50 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:border-primary-400 hover:text-primary-700`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {start > 1 && <span className="px-1 text-foreground-400">…</span>}
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`${btnBase} ${
            item === page
              ? "bg-primary-600 text-background-50"
              : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
          }`}
        >
          {item}
        </button>
      ))}
      {end < totalPages && <span className="px-1 text-foreground-400">…</span>}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btnBase} border border-background-300 bg-background-50 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:border-primary-400 hover:text-primary-700`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}